module.exports = __webpack_public_path__ + "img/cube.b7e06d95.svg";